
export default {
    name: 'SvgDamage',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
    },
};
